module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }